var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',[_c('router-view'),(_vm.chatIsOpen)?_c('ChatApp',{key:_vm.chatId,on:{"close":_vm.switchChat}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }